import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        question: '=',
        form: '=',
        counter: '=',
        answeredQuestions: '=',
        disabled: '<'
    },
    template: `
        <div class="alert alert-danger" ng-if="vm.form.answers[vm.question.id].errors.answerId">{{ vm.form.answers[vm.question.id].errors.answerId }}</div>
        <h3 ng-bind-html="vm.questionName | isRequired: vm.question.formQuestions[0].isRequired"></h3>
        <ul class="items10">
            <li ng-if="vm.question.imageFilename" ng-style="{ 'background-image': 'url('+vm.QuestionService.getImageUrl(vm.question, 'small')+')' }">
                <a class="overlay" ng-click="vm.openImageModal(vm.question)">{{ 'general.Zoom in' | translate }}</a>
            </li>
        </ul>
        <ul class="checkboxes inxcols">
            <li ng-repeat="answer in vm.question.questionAnswers">
                <label><input
                    type="checkbox"
                    ng-checked="vm.hasAnswer(answer.id)"
                    ng-click="vm.toggleAnswer(answer.id)"
                    ng-value="answer.id"
                    name="question-{{ vm.question.id }}-{{ answer.id }}"
                    ng-disabled="vm.disabled"
                ><span>{{ answer.text }}</span></label>
            </li>
        </ul>
    `
})
export default class {
    constructor (lodash, QuestionService) {
        this.lodash = lodash;
        this.QuestionService = QuestionService;
    }

    $onInit () {
        this.form.answers[this.question.id] = this.getAnswer();
        this.isAnswered = this.question.submittedAnswers && this.question.submittedAnswers.length;
        this.submittedAnswersAnswered = this.question.submittedAnswers.filter(answer => answer.answerId);

        if (this.isAnswered && this.submittedAnswersAnswered.length) {
            this.answeredQuestions = this.answeredQuestions + 1;
        }
        this.questionName = `${this.counter}. ${this.question.activeI18n.name}`;

        if (this.submittedAnswersAnswered) {
            this.submittedAnswersAnswered.forEach((submittedAnswer) => {
                const index = `${this.question.id}${submittedAnswer.answerId}`;
                this.form.answers[index] = this.getAnswer(submittedAnswer.answerId, submittedAnswer.id);
            });
            this.removeEmptyAnswer();
        }
    }

    hasAnswer (answerId) {
        return this.lodash.find(this.form.answers, { questionId: this.question.id, answerId }) !== undefined;
    }

    toggleAnswer (answerId) {
        const index = `${this.question.id}${answerId}`;
        if (this.hasAnswer(answerId)) {
            delete this.form.answers[index];
        }
        else {
            this.form.answers[index] = this.getAnswer(answerId);
        }
        this.updateAnsweredQuestions();
    }

    /**
     * This function removes empty answer from question
     */
    removeEmptyAnswer () {
        if (this.form.answers[this.question.id]) {
            delete this.form.answers[this.question.id];
        }
    }

    /**
     * This function adds empty answer to question, used to trigger validation
     */
    addEmptyAnswer () {
        if (!this.form.answers[this.question.id]) {
            this.form.answers[this.question.id] = this.getAnswer();
        }
    }

    getAnswer (answerId = null, submittedAnswerId = null) {
        return {
            id: submittedAnswerId,
            questionId: this.question.id,
            language: this.form.language,
            answerId
        };
    }

    updateAnsweredQuestions () {
        this.removeEmptyAnswer();
        const hasAnswer = this.lodash.find(this.form.answers, { questionId: this.question.id }) !== undefined;
        if (hasAnswer && !this.isAnswered) {
            this.answeredQuestions = this.answeredQuestions + 1;
            this.isAnswered = true;
        }
        else if (this.isAnswered && !hasAnswer) {
            this.answeredQuestions = this.answeredQuestions - 1;
            this.isAnswered = false;
        }

        if (!this.isAnswered) {
            this.addEmptyAnswer();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/survey/public/survey/question/checkbox/index.js